import * as React from "react";
import { useDispatch } from "react-redux";
import { paymentActions } from "../store/payment";
import SubscriptionChangeFinishPage from "../pages/SubscriptionChangeFinish";
import { PAYMENT_PLANS } from "../generated/lib-domain/paymentPlan";
import { PaymentPlanEnum } from "../generated/UserAPIAgent";
import { useOnceCall } from "../custom-hooks/once-call";

const SubscriptionChangeFinishContainer = () => {
    const dispatch = useDispatch();
    useOnceCall(() => {
        dispatch(paymentActions.selectedPaymentSet(null));
    });
    return (
        <SubscriptionChangeFinishPage
            // NOTE: 現状プランのダウングレードする導線は用意してないため、サブスクリプションの変更先はSTANDARD_1M_CARD_9800のみ
            planTitle={
                PAYMENT_PLANS.find(
                    (plan) => plan.id === PaymentPlanEnum.STANDARD_1M_CARD_9800
                ).title
            }
        />
    );
};

export default SubscriptionChangeFinishContainer;
